// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a811f2bb","455":"7ebd7f76","977":"b4e68ce3"}[chunkId] + ".chunk.js";
};